import { VerifyMatchDialog, VerifyMatchDialogProps } from './VerifyMatchDialog';

/**
 * Renders the verify-match dialog when list dialog props are available.
 * Null until a target has been opened at least once (preserves MUI exit transition).
 */
export function VerifyMatchListDialog({
  dialogProps,
}: {
  dialogProps: VerifyMatchDialogProps | null;
}) {
  if (!dialogProps) {
    return null;
  }

  return <VerifyMatchDialog {...dialogProps} />;
}
